import { z } from "zod";

export const bbCollectionIdSchema = z
  .string()
  .transform((v) => v.split("-")?.[0] ?? "");
